var _path, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHtmlicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E44D26",
    d: "M47.025,0.02l-4.014,44.958L24.974,49.98L6.981,44.984L2.974,0.02H47.025L47.025,0.02z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "29.542,9.211 25,9.211 24.981,9.211 21.917,9.211 11.172,9.211 11.304,10.691 12.659,25.891   25,25.891 25,25.889 31.771,25.889 31.132,33.041 24.981,34.699 23.371,34.27 23.371,34.27 18.832,33.046 18.44,28.646   12.905,28.646 13.676,37.305 22.273,39.69 22.273,39.69 22.328,39.705 24.973,40.439 24.998,40.434 24.998,40.433 36.287,37.303   36.371,36.371 37.665,21.853 37.8,20.373 24.981,20.373 24.981,20.375 17.703,20.375 17.199,14.727 21.917,14.727 24.981,14.727   25,14.727 29.542,14.727 38.305,14.727 38.412,13.487 38.663,10.691 38.796,9.211 "
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlicon);
export default __webpack_public_path__ + "static/media/htmlicon.0901620b08f24c3e228d1760fdfbbe34.svg";
export { ForwardRef as ReactComponent };